import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { OrganizationService } from "../../../../services/organization.service";
import { s25Resource } from "../../../../util/s25.resource";
import { S25ObjectDetailsService } from "../../../object-details/s25.object.details.service";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-categories-widget",
    template: `
        @if (categories().length) {
            <ul class="chips" aria-label="Categories">
                @for (category of categories(); track category.category_id) {
                    <li class="chip">{{ category.category_name }}</li>
                }
            </ul>
        }
    `,
    styles: `
        :host {
            display: block;
        }

        .chips {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .chip {
            padding: 0.25rem 0.75rem;
            background: var(--color--surface-2-bg);
            border: 1px solid var(--color--border);
            border-radius: 999px;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
})
export class SeOrgCategoriesWidgetComponent extends LayoutWidget<typeof SeOrgCategoriesWidgetComponent> {
    static readonly META = {
        name: "Categories",
        info: "Displays organization categories.",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);

    protected readonly categoriesResource = s25Resource({
        params: () => {
            const orgId = this.orgStore.orgId();
            if (!orgId) return undefined;
            return { orgId, version: this.orgStore.detailsVersion() };
        },
        loader: async ({ params: { orgId } }) => {
            const org = await OrganizationService.getOrganizationById(orgId, ["categories"]);
            return S25ObjectDetailsService.formatOrgCategories(org?.category);
        },
    });

    protected readonly categories = computed(() => this.categoriesResource.value() ?? []);
}
